<template>
  <u-animate-container id="banner">
    <div class="container" v-if="title == 'about'">
      <img src="@/assets/images/banner_about.jpg" class="bg" />
      <u-animate
        class="txt"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div style="font-size: 0.6rem;color:white">
          {{ $i18n.locale === "zh-cn" ? "关于西河" : "ABOUT" }}
        </div>
      </u-animate>
    </div>
    <div class="container" v-if="title == 'new'">
      <img src="@/assets/images/news.jpg" class="bg" />
      <u-animate
        class="txt"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div style="font-size: 0.6rem;color:white">
          {{ $i18n.locale === "zh-cn" ? "新闻" : "NEWS" }}
        </div>
      </u-animate>
    </div>
    <div class="container" v-else-if="title == 'contact'">
      <img src="@/assets/images/banner_contact.jpg" class="bg" />
      <u-animate
        class="txt"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div style="font-size: 0.6rem;color:white">
          {{ $i18n.locale === "zh-cn" ? "联络我们" : "CONTACT" }}
        </div>
      </u-animate>
    </div>
    <div class="container" v-else-if="title == 'solution'">
      <img src="@/assets/images/qcjg1.png" class="bg" />
      <u-animate
        class="txt"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
      </u-animate>
      <common-title :cn="$t('solution.title')"></common-title>
    </div>
    <div class="container" v-else-if="title == 'product'">
      <img src="@/assets/images/banner_product.jpg" class="bg" />

      <u-animate
        class="txt"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <span style="color:#fff">
          {{ $i18n.locale === "zh-cn" ? "产品中心" : "PRODUCT" }}
        </span>
      </u-animate>
    </div>
    <div class="container" v-else-if="title == 'sdwyj'">
      <img src="@/assets/images/sdwyj_img1.png" class="bg" />
      <common-title :cn="$t('sdwyj.title')"></common-title>
    </div>
    <div class="container" v-else-if="title == 'gfjgfa'">
      <img src="@/assets/images/gf1.png" class="bg" />
      <common-title :cn="$t('gfjgfa.title')"></common-title>
    </div>
    <div class="container" v-else-if="title == 'gdjt'">
      <img src="@/assets/images/gdjt1.png" class="bg" />
      <common-title :cn="$t('gdjt.title')"></common-title>
    </div>
    <div class="container" v-else-if="title == 'htjs'">
      <img src="@/assets/images/htjs1.png" class="bg" />
      <common-title :cn="$t('htjs.title')"></common-title>
    </div>
    <div class="container" v-else-if="title == 'fzlc'">
      <img src="@/assets/images/history01.jpg" class="bg" />
    </div>
    <div class="container" v-else-if="title == 'zzrz'">
      <img src="@/assets/images/zzrz01.jpg" class="bg" />
    </div>
    <div class="container" v-else-if="title == 'xhpk'">
      <img src="@/assets/images/quality01.jpg" class="bg" />
    </div>
    <div class="container" v-else-if="title == 'xnyqc'">
      <img src="@/assets/images/banner_solution.jpg" class="bg" />
      <u-animate
        class="txt"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div style="font-size: 0.6rem;color:white">
          {{ $i18n.locale === "zh-cn" ? "解决方案" : "SOLUTION" }}
        </div>
      </u-animate>
    </div>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonTitle from "./TitleWhite.vue";
export default {
  components: {
    UAnimateContainer,
    CommonTitle,
    UAnimate
  },
  data() {
    return {
      banner_title: ""
    };
  },
  mounted() {
    this.banner_title = this.title;
  },
  props: ["title"]
};
</script>
<style scoped lang="scss">
#banner {
  margin-top: 100px;
  .container {
    width: 100%;
    position: relative;
    display: flex;
    display: -ms-flexbox;
    align-items: center;
    justify-content: center;
    img.bg {
      width: 100%;
      height: auto;
    }
    .txt {
      width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      display: flex;
      display: -ms-flexbox;
      align-items: center;
      justify-content: center;
      img {
        width: 250px;
        height: auto;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #banner {
    margin-top: 60px;
    .container {
      img.bg {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }
      .txt {
        img {
          width: 5rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Common/Banner.vue